import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListUserCollectionsResponse } from './list-user-collections-response';
import { listUserCollectionsResponseSchema } from './list-user-collections-response';

export async function listUserCollectionsApi(): Promise<
  IValidatedResponse<IListUserCollectionsResponse>
> {
  return getRequest<IListUserCollectionsResponse>({
    path: '/user-collections',
    schema: listUserCollectionsResponseSchema,
  });
}
